import type { NavigationGuard, Router } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { navFor, PUBLIC_ROUTE_NAMES } from '@/router/navigation';

/**
 * Mirrors the legacy AngularJS guard (shared-controllers/main.js):
 *   - Public routes are always allowed.
 *   - Unauthenticated requests to a non-public route → redirect to `/`.
 *   - Authenticated requests to routes NOT in the user's nav table are blocked.
 */
export const authGuard: NavigationGuard = (to) => {
  const auth = useAuthStore();
  const routeName = typeof to.name === 'string' ? to.name : null;
  const isPublic = routeName !== null && PUBLIC_ROUTE_NAMES.has(routeName);

  if (isPublic) return true;

  if (!auth.isLoggedIn) {
    return { name: 'main' };
  }

  const allowed = navFor(auth.emslUserType).some((item) => item.pageSignature === routeName);
  if (!allowed) {
    return false;
  }

  return true;
};

export function installAuthGuard(router: Router): void {
  router.beforeEach(authGuard);
}
